var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_178_2",
    "data-name": "Component 178 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 20,
    viewBox: "0 0 19.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_dollar_light",
    "data-name": "UI icon/dollar/light",
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M3,0a.442.442,0,0,1,.429.455V.909h.857A1.769,1.769,0,0,1,6,2.727v.455a.429.429,0,1,1-.857,0V2.727a.884.884,0,0,0-.857-.909H1.714a.884.884,0,0,0-.857.909V2.78a1.359,1.359,0,0,0,.879,1.294l2.8.989A2.266,2.266,0,0,1,6,7.22v.053A1.769,1.769,0,0,1,4.286,9.091H3.429v.455a.429.429,0,1,1-.857,0V9.091H1.714A1.769,1.769,0,0,1,0,7.273V6.818a.442.442,0,0,1,.429-.455.442.442,0,0,1,.429.455v.455a.884.884,0,0,0,.857.909H4.286a.884.884,0,0,0,.857-.909V7.22a1.359,1.359,0,0,0-.879-1.294l-2.8-.989A2.266,2.266,0,0,1,0,2.78V2.727A1.769,1.769,0,0,1,1.714.909h.857V.455A.442.442,0,0,1,3,0Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_reload_light",
    "data-name": "UI icon/reload/light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union-2",
    "data-name": "Union",
    d: "M2,10a8,8,0,0,1,8-8,7.846,7.846,0,0,1,6.182,2.993l-1.679,0a1,1,0,1,0-.006,2L17.94,7a1,1,0,0,0,.116,0H18.5a1,1,0,0,0,1-1V2a1,1,0,0,0-2,0V3.449A9.83,9.83,0,0,0,10,0a10,10,0,1,0,8.9,14.445,1,1,0,1,0-1.791-.89A7.9,7.9,0,0,1,10,18,8,8,0,0,1,2,10Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.c6567c38822dfb5ffddf2434ca00be94.svg";
export { ForwardRef as ReactComponent };